import React from 'react';
import ReactDOM from 'react-dom';
import './backdrop.scss';
import useHasMounted from '../../../../hooks/client-only-hook';

var Backdrop = function Backdrop(_ref) {
  var onClick = _ref.onClick;
  var hasMounted = useHasMounted();

  if (!hasMounted) {
    return null;
  }

  var backdrop = document.getElementById('backdrop-hook');

  if (!backdrop) {
    throw new Error('Backdrop element not found');
  }

  return /*#__PURE__*/ReactDOM.createPortal( /*#__PURE__*/React.createElement("div", {
    className: "backdrop",
    onClick: onClick,
    onKeyDown: onClick // dealt with "jsx-a11y/click-events-have-key-events"
    ,
    role: "presentation" // dealt with "jsx-a11y/no-noninteractive-element-interactions"

  }), backdrop);
};

export default Backdrop;